module.exports = __webpack_public_path__ + "img/battery.79829a87.svg";